import { render, staticRenderFns } from "./PanicAlertMainView.vue?vue&type=template&id=67361be4&scoped=true"
import script from "./PanicAlertMainView.vue?vue&type=script&lang=js"
export * from "./PanicAlertMainView.vue?vue&type=script&lang=js"
import style0 from "./PanicAlertMainView.vue?vue&type=style&index=0&id=67361be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67361be4",
  null
  
)

export default component.exports